import styled from 'styled-components';

export const StyledInfo = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
`;
